var _toArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

(function () {
  "use strict";

  var e = {
    130: function _(e, t, n) {
      n.d(t, {
        Z: function Z() {
          return s;
        }
      });
      var o = n(81),
          r = n.n(o),
          i = n(645),
          a = n.n(i)()(r());
      a.push([e.id, ':root{--font-stack: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"}.dUaCAewWeJuTScQ7UMZf{padding:16px 16px 13px 16px;border-radius:8px;background-color:#083b94;font-family:var(--font-stack);font-size:18px;font-weight:600;text-align:center;color:#fff}.dUaCAewWeJuTScQ7UMZf:hover{cursor:pointer}.B9_PK16XTkTGt6w7co_o{padding:7px 13px;border-radius:3px;display:block;border:solid 1px #083b94;font-family:var(--font-stack);font-size:12px;text-align:center;color:#083b94}.B9_PK16XTkTGt6w7co_o:hover{cursor:pointer}', ""]), a.locals = {
        fusionAuthButton: "dUaCAewWeJuTScQ7UMZf",
        fusionAuthLogoutButton: "B9_PK16XTkTGt6w7co_o"
      };
      var s = a;
    },
    645: function _(e) {
      e.exports = function (e) {
        var t = [];
        return t.toString = function () {
          return this.map(function (t) {
            var n = "",
                o = void 0 !== t[5];
            return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), o && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e(t), o && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
          }).join("");
        }, t.i = function (e, n, o, r, i) {
          "string" == typeof e && (e = [[null, e, void 0]]);
          var a = {};
          if (o) for (var s = 0; s < this.length; s++) {
            var c = this[s][0];
            null != c && (a[c] = !0);
          }

          for (var u = 0; u < e.length; u++) {
            var l = [].concat(e[u]);
            o && a[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), n && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = n) : l[2] = n), r && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = r) : l[4] = "".concat(r)), t.push(l));
          }
        }, t;
      };
    },
    81: function _(e) {
      e.exports = function (e) {
        return e[1];
      };
    },
    379: function _(e) {
      var t = [];

      function n(e) {
        for (var n = -1, o = 0; o < t.length; o++) {
          if (t[o].identifier === e) {
            n = o;
            break;
          }
        }

        return n;
      }

      function o(e, o) {
        for (var i = {}, a = [], s = 0; s < e.length; s++) {
          var c = e[s],
              u = o.base ? c[0] + o.base : c[0],
              l = i[u] || 0,
              d = "".concat(u, " ").concat(l);
          i[u] = l + 1;
          var p = n(d),
              f = {
            css: c[1],
            media: c[2],
            sourceMap: c[3],
            supports: c[4],
            layer: c[5]
          };
          if (-1 !== p) t[p].references++, t[p].updater(f);else {
            var v = r(f, o);
            o.byIndex = s, t.splice(s, 0, {
              identifier: d,
              updater: v,
              references: 1
            });
          }
          a.push(d);
        }

        return a;
      }

      function r(e, t) {
        var n = t.domAPI(t);
        return n.update(e), function (t) {
          if (t) {
            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
            n.update(e = t);
          } else n.remove();
        };
      }

      e.exports = function (e, r) {
        var i = o(e = e || [], r = r || {});
        return function (e) {
          e = e || [];

          for (var a = 0; a < i.length; a++) {
            var s = n(i[a]);
            t[s].references--;
          }

          for (var c = o(e, r), u = 0; u < i.length; u++) {
            var l = n(i[u]);
            0 === t[l].references && (t[l].updater(), t.splice(l, 1));
          }

          i = c;
        };
      };
    },
    569: function _(e) {
      var t = {};

      e.exports = function (e, n) {
        var o = function (e) {
          if (void 0 === t[e]) {
            var n = document.querySelector(e);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (e) {
              n = null;
            }
            t[e] = n;
          }

          return t[e];
        }(e);

        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(n);
      };
    },
    216: function _(e) {
      e.exports = function (e) {
        var t = document.createElement("style");
        return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
      };
    },
    565: function _(e, t, n) {
      e.exports = function (e) {
        var t = n.nc;
        t && e.setAttribute("nonce", t);
      };
    },
    795: function _(e) {
      e.exports = function (e) {
        var t = e.insertStyleElement(e);
        return {
          update: function update(n) {
            !function (e, t, n) {
              var o = "";
              n.supports && (o += "@supports (".concat(n.supports, ") {")), n.media && (o += "@media ".concat(n.media, " {"));
              var r = void 0 !== n.layer;
              r && (o += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), o += n.css, r && (o += "}"), n.media && (o += "}"), n.supports && (o += "}");
              var i = n.sourceMap;
              i && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(o, e, t.options);
            }(t, e, n);
          },
          remove: function remove() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(t);
          }
        };
      };
    },
    589: function _(e) {
      e.exports = function (e, t) {
        if (t.styleSheet) t.styleSheet.cssText = e;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(e));
        }
      };
    }
  },
      t = {};

  function n(o) {
    var r = t[o];
    if (void 0 !== r) return r.exports;
    var i = t[o] = {
      id: o,
      exports: {}
    };
    return e[o](i, i.exports, n), i.exports;
  }

  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var o in t) {
      n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.nc = void 0;
  var o = {};

  (function () {
    n.r(o), n.d(o, {
      FusionAuthContext: function FusionAuthContext() {
        return c;
      },
      FusionAuthLoginButton: function FusionAuthLoginButton() {
        return M;
      },
      FusionAuthLogoutButton: function FusionAuthLogoutButton() {
        return N;
      },
      FusionAuthProvider: function FusionAuthProvider() {
        return u;
      },
      FusionAuthRegisterButton: function FusionAuthRegisterButton() {
        return I;
      },
      RequireAuth: function RequireAuth() {
        return R;
      },
      useFusionAuth: function useFusionAuth() {
        return l;
      },
      withFusionAuth: function withFusionAuth() {
        return j;
      }
    });

    var e = require("react");

    var t = n.n(e);

    var r = require("js-cookie");

    var i = n.n(r),
        a = function a(e, t, n, o) {
      return new (n || (n = Promise))(function (r, i) {
        function a(e) {
          try {
            c(o.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            c(o.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((o = o.apply(e, t || [])).next());
      });
    };

    var s = "openid offline_access",
        c = t().createContext({
      login: function login() {
        return Promise.resolve();
      },
      logout: function logout() {
        return Promise.resolve();
      },
      register: function register() {
        return Promise.resolve();
      },
      user: {},
      isLoading: !1,
      isAuthenticated: !1,
      refreshToken: function refreshToken() {
        return Promise.resolve();
      }
    }),
        u = function u(n) {
      var o = n.children,
          _ref = (0, e.useState)(function () {
        return !!i().get("app.at_exp");
      }),
          _ref2 = _slicedToArray(_ref, 2),
          r = _ref2[0],
          u = _ref2[1],
          _ref3 = (0, e.useState)(!1),
          _ref4 = _slicedToArray(_ref3, 2),
          l = _ref4[0],
          p = _ref4[1],
          _ref5 = (0, e.useState)({}),
          _ref6 = _slicedToArray(_ref5, 2),
          v = _ref6[0],
          h = _ref6[1],
          g = (0, e.useCallback)(function (e, t, o) {
        var r = new URLSearchParams(o),
            i = r.toString().length > 0 ? "?".concat(r) : "",
            a = t || "/app/".concat(e);
        return "".concat(n.serverUrl).concat(a).concat(i);
      }, [n.serverUrl]),
          m = (0, e.useCallback)(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return a(void 0, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var t, o, r;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  o = "".concat(f(), ":").concat(e);
                  i().set("lastState", o);
                  r = g(d.login, n.loginPath, {
                    client_id: n.clientID,
                    scope: null !== (t = n.scope) && void 0 !== t ? t : s,
                    redirect_uri: n.redirectUri,
                    state: o
                  });
                  window.location.assign(r);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      }, [g, n.clientID, n.redirectUri, n.loginPath, n.scope]),
          y = (0, e.useCallback)(function () {
        return a(void 0, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var e, t;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  i().remove("user"), i().remove("lastState");
                  e = {
                    client_id: n.clientID,
                    post_logout_redirect_uri: n.redirectUri
                  }, t = g(d.logout, n.logoutPath, e);
                  window.location.assign(t);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      }, [g, n.clientID, n.logoutPath, n.redirectUri]),
          b = (0, e.useCallback)(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return a(void 0, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          var t, o, r;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  o = "".concat(f(), ":").concat(e);
                  i().set("lastState", o);
                  r = g(d.register, n.registerPath, {
                    client_id: n.clientID,
                    redirect_uri: n.redirectUri,
                    scope: null !== (t = n.scope) && void 0 !== t ? t : s,
                    state: o
                  });
                  window.location.assign(r);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
      }, [g, n.clientID, n.redirectUri, n.registerPath, n.scope]);

      (0, e.useEffect)(function () {
        var e = i().get("user");
        if (e) try {
          h(JSON.parse(e));
        } catch (e) {}
      }, [h]);
      var x = (0, e.useCallback)(function () {
        return a(void 0, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          var e, t, o;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  t = i().get("app.at_exp"), o = null !== (e = n.accessTokenExpireWindow) && void 0 !== e ? e : 3e4;
                  _context4.t0 = void 0 === t || Number(t) < Date.now() + o;

                  if (!_context4.t0) {
                    _context4.next = 5;
                    break;
                  }

                  _context4.next = 5;
                  return fetch(g(d.tokenRefresh, n.tokenRefreshPath), {
                    method: "POST",
                    headers: {
                      "content-type": "text/plain"
                    },
                    credentials: "include"
                  });

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
      }, [g, n.tokenRefreshPath, n.accessTokenExpireWindow]);
      (0, e.useLayoutEffect)(function () {
        if (l) return;
        var e = i().get("lastState");
        i().get("app.at_exp") ? (u(!0), i().get("user") || (p(!0), fetch(g(d.me, null == n ? void 0 : n.mePath), {
          credentials: "include"
        }).then(function (e) {
          return e.json();
        }).then(function (t) {
          var o;

          if (i().set("user", JSON.stringify(t)), h(t), e) {
            var _e$split = e.split(":"),
                _e$split2 = _toArray(_e$split),
                _t = _e$split2.slice(1),
                _r = _t.join(":");

            null === (o = n.onRedirectSuccess) || void 0 === o || o.call(n, _r);
          }
        }).catch(function (e) {
          var t;
          null === (t = n.onRedirectFail) || void 0 === t || t.call(n, e);
        }).finally(function () {
          return p(!1);
        }))) : u(!1);
      }, [l, g, n]);
      var S = (0, e.useMemo)(function () {
        return {
          login: m,
          logout: y,
          register: b,
          isAuthenticated: r,
          isLoading: l,
          user: v,
          refreshToken: x
        };
      }, [m, y, b, r, l, x, v]);
      return t().createElement(c.Provider, {
        value: S
      }, o);
    },
        l = function l() {
      return (0, e.useContext)(c);
    };

    var d;

    function p(e) {
      return ("0" + e.toString(16)).substr(-2);
    }

    function f() {
      var e = new Uint32Array(28);
      return window.crypto.getRandomValues(e), Array.from(e, p).join("");
    }

    !function (e) {
      e.login = "login", e.logout = "logout", e.register = "register", e.tokenRefresh = "refresh", e.me = "me";
    }(d || (d = {}));

    var v = n(379),
        h = n.n(v),
        g = n(795),
        m = n.n(g),
        y = n(569),
        b = n.n(y),
        x = n(565),
        S = n.n(x),
        w = n(216),
        A = n.n(w),
        P = n(589),
        k = n.n(P),
        _ = n(130),
        T = {};

    T.styleTagTransform = k(), T.setAttributes = S(), T.insert = b().bind(null, "head"), T.domAPI = m(), T.insertStyleElement = A(), h()(_.Z, T);

    var C = _.Z && _.Z.locals ? _.Z.locals : void 0,
        U = require("classnames");

    var E = n.n(U);

    var M = function M(_ref7) {
      var e = _ref7.state,
          n = _ref7.text,
          o = _ref7.className;

      var _l = l(),
          r = _l.login;

      return t().createElement("button", {
        className: E()(C.fusionAuthButton, o),
        type: "button",
        onClick: function onClick() {
          return r(null != e ? e : "");
        }
      }, null != n ? n : "Login");
    },
        N = function N(_ref8) {
      var e = _ref8.text,
          n = _ref8.className;

      var _l2 = l(),
          o = _l2.logout;

      return t().createElement("button", {
        className: E()(C.fusionAuthLogoutButton, n),
        type: "button",
        onClick: function onClick() {
          return o();
        }
      }, null != e ? e : "Logout");
    },
        I = function I(_ref9) {
      var e = _ref9.state,
          n = _ref9.text,
          o = _ref9.className;

      var _l3 = l(),
          r = _l3.register;

      return t().createElement("button", {
        className: E()(C.fusionAuthButton, o),
        type: "button",
        onClick: function onClick() {
          return r(null != e ? e : "");
        }
      }, null != n ? n : "Register Now");
    },
        R = function R(_ref10) {
      var e = _ref10.withRole,
          n = _ref10.children;

      var _l4 = l(),
          o = _l4.user,
          r = _l4.isAuthenticated,
          i = !e || [].concat(e).some(function (e) {
        var t;
        return null === (t = null == o ? void 0 : o.roles) || void 0 === t ? void 0 : t.includes(e);
      }),
          a = r && i;

      return t().createElement(t().Fragment, null, a && n);
    },
        j = function j(e) {
      var n = e.displayName,
          o = function o(n) {
        return t().createElement(c.Consumer, null, function (o) {
          return t().createElement(e, Object.assign({}, n, {
            fusionAuth: o
          }));
        });
      };

      return o.displayName = n, o;
    };
  })();

  var r = exports;

  for (var i in o) {
    r[i] = o[i];
  }

  o.__esModule && Object.defineProperty(r, "__esModule", {
    value: !0
  });
})();